import React from 'react';
import { ThemeProvider, CssBaseline, Box, AppBar, Toolbar, Typography, Container } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import theme from './theme.js';
import OrderTracking from './pages/OrderTracking.js';
import AuthPage from './pages/AuthPage.js';
import AuthAppBarActions from './components/AuthAppBarActions.js';

import useAuth from './hooks/useAuth.js';
import { CircularProgress } from '@mui/material';


function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh"><CircularProgress color="primary" /></Box>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AuthRedirect({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh"><CircularProgress color="primary" /></Box>;
  if (user) return <Navigate to="/" state={{ from: location }} replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{bgcolor: 'background.default', color: 'text.primary' }}>
          <Container maxWidth="xxl" sx={{ py: { xs: 0, md: 0 } }}>
            <Routes>
              <Route path="/login" element={<AuthRedirect><AuthPage /></AuthRedirect>} />
              <Route path="/" element={<ProtectedRoute><OrderTracking /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Container>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
